import { NavLink } from "react-router-dom";
import { Gem, Sparkles, Coins, Gift } from "lucide-react";

const TABS = [
  {
    to: "/",
    end: true,
    id: "diamonds",
    label: "Diamantes",
    sub: "Free Fire",
    Icon: Gem,
    color: "#ff4500",
    testid: "tab-diamonds",
  },
  {
    to: "/evolutivos",
    id: "evolutivos",
    label: "Evolutivos",
    sub: "Tokens & Cajas",
    Icon: Sparkles,
    color: "#ff8a00",
    testid: "tab-evolutivos",
  },
  {
    to: "/robux",
    id: "robux",
    label: "Robux",
    sub: "Roblox",
    Icon: Coins,
    color: "#22c55e",
    testid: "tab-robux",
  },
  {
    to: "/recompensas",
    id: "recompensas",
    label: "Recompensas",
    sub: "Cajas sorpresa",
    Icon: Gift,
    color: "#fbbf24",
    testid: "tab-recompensas",
  },
];

export default function CategoryTabs({ active }) {
  return (
    <section
      className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-6 pb-2"
      aria-label="Categorías"
    >
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
        {TABS.map((t) => {
          const isActive = active ? active === t.id : false;
          return (
            <NavLink
              key={t.id}
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive: routeActive }) => {
                const on = active ? isActive : routeActive;
                return `group relative flex items-center gap-3 rounded-xl p-3 sm:p-4 border overflow-hidden ${on ? "" : "hover:-translate-y-0.5"}`;
              }}
              style={({ isActive: routeActive }) => {
                const on = active ? isActive : routeActive;
                return {
                  background: on ? `${t.color}18` : "#0d0d0d",
                  borderColor: on ? t.color : "rgba(255,255,255,0.08)",
                  boxShadow: on ? `0 8px 30px ${t.color}44, inset 0 0 0 1px ${t.color}55` : "none",
                  transition: "transform 200ms ease, border-color 200ms ease, background 200ms ease, box-shadow 200ms ease",
                };
              }}
            >
              {({ isActive: routeActive }) => {
                const on = active ? isActive : routeActive;
                const Icon = t.Icon;
                return (
                  <>
                    <div
                      className="w-10 h-10 sm:w-11 sm:h-11 rounded-md grid place-items-center shrink-0"
                      style={{
                        background: "#0a0a0a",
                        border: `1px solid ${t.color}66`,
                        filter: on ? `drop-shadow(0 0 10px ${t.color}aa)` : "none",
                      }}
                    >
                      <Icon className="w-5 h-5 sm:w-6 sm:h-6" style={{ color: t.color }} strokeWidth={2.2} />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="font-display text-lg sm:text-xl tracking-wider text-white leading-tight">
                        {t.label}
                      </div>
                      <div className="text-[10px] uppercase tracking-widest text-neutral-400 truncate">
                        {t.sub}
                      </div>
                    </div>
                    {on && (
                      <span
                        className="absolute top-2 right-2 text-[9px] px-1.5 py-0.5 rounded font-bold hidden sm:inline-block"
                        style={{ background: t.color, color: "#000" }}
                      >
                        ACTIVO
                      </span>
                    )}
                  </>
                );
              }}
            </NavLink>
          );
        })}
      </div>
    </section>
  );
}
